import React from "react";
import ReactDOM from "react-dom/client";

import App from "./app/App";
import { fixAutotranslateCrash } from "./fixAutotranslateCrashHack";
import "./index.css";

// This is a hack suggested by Dan Abramov to fix a crash caused by
// Google Chrome's auto-translate feature.
fixAutotranslateCrash();

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
